module.exports = __webpack_public_path__ + "static/media/iceberg-logo.cfbdeca6.svg";